<template>
  <section class="lbs-viewer-right-side">
    <div :id="uScopeDivId"
         class="lbs-uscope-container"/>
  </section>
</template>

<script>
  import {set} from 'lodash';
  import { createId } from '../../shared/util';

  export default {
    name: 'UscopeComponent',
    props: {
      config: {
        type: Object,
        required: true
      }
    },
    data () {
      const uScopeDivId = createId();
      set(this.config.legacyConfig, 'uScope.setup.divId', uScopeDivId);
      return {
        // Note that  contains a div ID but we're not using it anymore
        uScopeDivId
      };
    }
  };
</script>

<style lang="scss">
  .lbs-viewer-container{
    .lbs-viewer-right-side {
      -ms-grid-row: 2;
      -ms-grid-column: 2;
      grid-area: right-side;
      flex-grow: 1;
    }
    // Viewing area layout
    .lbs-viewer-right-side {
      .lbs-uscope-container {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/viewer/components/UscopeComponent.vue